import React, { useEffect, useReducer } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { PageContainer } from '@ant-design/pro-layout';
import { Breadcrumb, Card } from 'antd';
import { GET_PROJECT_APPLICATION } from 'gql/projectApplications';
import { Error404 } from 'components/layout/ErrorPage';
import { Link, Main } from 'components/layout';
import EditProjectApplication from './components/EditProjectApplication';
import SubmitProjectApplication from './components/SubmitProjectApplication';
import PendingProjectApplication from './components/PendingProjectApplication';
import ResultProjectApplication from './components/ResultProjectApplication';
import ProjectApplicationStep from './components/ProjectApplicationStep';
import { useQueryParams } from 'hooks';

const Detail = ({ page, reducer }) => {
  switch (page) {
    case 'EDIT':
      return <EditProjectApplication reducer={reducer} />;
    case 'SUBMIT':
      return <SubmitProjectApplication reducer={reducer} />;
    case 'PENDING':
      return <PendingProjectApplication reducer={reducer} />;
    case 'RESULT':
      return <ResultProjectApplication />;
    case 'OVERDUE':
      return <ResultProjectApplication />;
    default:
      return <Card loading={true} />;
  }
};

const initialState = { step: null, page: '' };
const reducer = (_state, action) => {
  switch (action.type) {
    case 'APPLY':
      return { step: 0, page: 'EDIT' };
    case 'SUBMIT':
      return { step: 1, page: 'SUBMIT' };
    case 'APPROVAL':
      return { step: 2, page: 'PENDING' };
    case 'RESULT':
      return { step: 3, page: 'RESULT' };
    case 'OVERDUE':
      return { step: 3, page: 'OVERDUE' };
    default:
      return initialState;
  }
};

const ProjectApplication = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION, {
    variables: {
      id: id,
    },
  });
  const action = useQueryParams()?.get('action');
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (!loading) {
      const status = data?.projectApplication?.status;
      switch (status) {
        case 'DRAFT':
          if (action === 'submit') {
            dispatch({ type: 'SUBMIT' });
            break;
          }
          dispatch({ type: 'APPLY' });
          break;
        case 'PENDING':
          dispatch({ type: 'APPROVAL' });
          break;
        case 'OVERDUE':
          dispatch({ type: 'OVERDUE' });
          break;
        case 'APPROVED':
        case 'REJECTED':
        case 'VOIDED':
        default:
          dispatch({ type: 'RESULT' });
          break;
      }
    }
  }, [loading, data, action]);

  // if (loading || state.step === null) {
  //   return <Spin />;
  // }

  if (!data?.projectApplication === 0) {
    return <Error404 />;
  }

  return (
    <Main>
      <PageContainer
        ghost
        // loading={loading}
        header={{
          title: 'Funding Application',
          breadcrumb: (
            <Breadcrumb style={{ marginBottom: '16px' }}>
              <Breadcrumb.Item>
                <Link to="/project-applications/my">Funding Applications</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {data?.projectApplication?.setting?.title ||
                  'Submit Funding Application'}
              </Breadcrumb.Item>
            </Breadcrumb>
          ),
        }}
      >
        <Card>
          <ProjectApplicationStep current={state.step} />
          <Detail page={state.page} reducer={{ dispatch }} />
        </Card>
      </PageContainer>
    </Main>
  );
};

export default ProjectApplication;
